module.exports = {
	"library.navbar.sign_up": "Rekisteröidy",
	"library.navbar.sign_in": "Kirjaudu sisään",
	"library.navbar.sign_out": "Kirjaudu ulos",
	"library.navbar.help": "Ohje",
	"library.navbar.search_for_events": "Hae tapahtumia",
	"library.navbar.enter_location": "Enter location",
	"library.navbar.find_events": "Etsi tapahtumia",
	"library.navbar.create_event": "Luo tapahtuma",
	"library.navbar.host_events": "Järjestä tapahtumia",
	"library.navbar.dashboard": "Koontinäyttö",
	"library.navbar.my_events": "Omat tapahtumat",
	"library.navbar.my_tickets": "Omat liput",
	"library.navbar.admin_panel": "Admin panel",
	"library.navbar.profile": "Profiili",
	"library.navbar.messages": "Viestit",
	"library.navbar.settings": "Asetukset",
	"library.navbar.search_cities": "Etsi kaupunkeja",
	"library.navbar.help_center": "Tukipalvelu",
	"library.navbar.cant_find_tickets": "Missä ovat lippuni?",
	"library.navbar.contact_organizer": "Ota yhteyttä tapahtuman järjestäjään",
	"library.navbar.can_refund": "Voinko saada hyvityksen?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/fi.json
// module id = 1512
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16